import { render, staticRenderFns } from "./planning-allocation.vue?vue&type=template&id=c3d955a2&"
import script from "./planning-allocation.vue?vue&type=script&lang=js&"
export * from "./planning-allocation.vue?vue&type=script&lang=js&"
import style0 from "./planning-allocation.vue?vue&type=style&index=0&id=c3d955a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports